














import { Component, Vue } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'

@Component({
  components: {
    LazyHydrate,
    ComponentHeaderTopLineType1: () =>
      import('~/components/header/header-top-line-type-1.vue'),
    ComponentHeaderMainLineType1: () =>
      import('~/components/header/header-main-line-type-1.vue'),
    ComponentHeaderMenu: () => import('~/components/header/header-menu.vue'),
  },
})
export default class ComponentHeaderVariant1 extends Vue {
  private mounted() {
    this.$emit('loaded')
  }
}
